const config = process.env.VUE_APP_FIREBASE_CONFIG;

export default JSON.parse(config);
